import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

import { addLocaleData, IntlProvider, intlShape } from 'react-intl'
import enLocaleData from 'react-intl/locale-data/en'
import viLocaleData from 'react-intl/locale-data/vi'
import jaLocaleData from 'react-intl/locale-data/ja'
import enMessages from '../intl/en'
import viMessages from '../intl/vi'
import jaMessages from '../intl/ja'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import lightTheme from './themes/lightTheme'
import darkTheme from './themes/darkTheme'
import grayTheme from './themes/grayTheme'

import injectTapEventPlugin from 'react-tap-event-plugin'

injectTapEventPlugin() // Needed for onTouchTap for Material UI

// = styles =
// 3rd
import 'styles/bootstrap.scss'
// custom
import 'styles/layout.scss'
import 'styles/theme.scss'
import 'styles/ui.scss'
import 'styles/app.scss'

// setup global locale data
addLocaleData(enLocaleData)
addLocaleData(viLocaleData)
addLocaleData(jaLocaleData)

const locales = {
  en: {
    locale: 'en',
    messages: enMessages
  },
  vi: {
    locale: 'vi',
    messages: viMessages
  },
  ja: {
    locale: 'ja',
    messages: jaMessages
  }
}

class App extends Component {
  static propsType = {
    intl: intlShape.isRequired
  }

  state = {
    windowWidth: window.innerWidth
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize)
  }

  handleWindowResize = () => {
    this.setState({ windowWidth: window.innerWidth })
  }

  render() {
    const { layoutBoxed, navCollapsed, navBehind, fixedHeader, sidebarWidth, theme, language } = this.props

    let materialUITheme
    switch (theme) {
      case 'gray':
        materialUITheme = grayTheme
        break
      case 'dark':
        materialUITheme = darkTheme
        break
      default:
        materialUITheme = lightTheme
    }

    return (
      <IntlProvider {...locales[language]}>
        <MuiThemeProvider muiTheme={getMuiTheme(materialUITheme)}>
          <div id="app-inner">
            <div className="preloaderbar hide">
              <span className="bar"></span>
            </div>
            <div
              className={classnames('full-height', {
                'fixed-header': fixedHeader,
                'nav-collapsed': navCollapsed || this.state.windowWidth < 992,
                'nav-behind': navBehind,
                'layout-boxed': layoutBoxed,
                'theme-gray': theme === 'gray',
                'theme-dark': theme === 'dark',
                'sidebar-sm': sidebarWidth === 'small',
                'sidebar-lg': sidebarWidth === 'large'
              })}
            >
              {this.props.children}
            </div>
          </div>
        </MuiThemeProvider>
      </IntlProvider>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    language: state.language,
    layoutBoxed: state.settings.layoutBoxed,
    navCollapsed: state.settings.navCollapsed,
    navBehind: state.settings.navBehind,
    fixedHeader: state.settings.fixedHeader,
    sidebarWidth: state.settings.sidebarWidth,
    theme: state.settings.theme
  }
}

module.exports = connect(mapStateToProps)(App)



// WEBPACK FOOTER //
// ./containers/App.js